<template>
    <Layout :clientId='clientId' :channels='channels' :setTitle='title' :ads='ads' :apiOrigin="apiOrigin">
        <div class="news-view">
            <div :class="setCityClass" class="article" v-if="article.news_type!=2">
                <!-- 新闻开始 -->
                <h1 class="media-heading">{{article.title}}</h1>
                <p class="last">
                    <span v-show="article.source">来源：{{article.source}}</span>
                    <span v-if="article.author && clientId==410600">编辑：{{article.author}}</span>
                    <span v-if="article.author && clientId!==410600">作者：{{article.author}}</span>
                    <span v-show="article.released_at">{{format(new Date(article.released_at*1000),'YYYY-MM-DD')}}</span>
                    <span class="views" v-show="article.views||article.views==0&&(!(clientId==321300||clientId==320100))">{{article.views}}人阅读</span>
                </p>
                <div class="content" v-html="article.body" v-if="clientId==320598" :class="msg">
                    <span></span>
                </div>
                <div class="content" v-html="article.body" v-if="clientId!==320598">
                    <span></span>
                </div>
                <!-- 右侧列表开始 -->
            </div>
            <div v-if="article.news_type!=2&&article.relationsNews.length>0" class="aside">
                <newsImgAside title="相关新闻" type='2' :clientId="clientId" :list="article.relationsNews"></newsImgAside>
            </div>
        </div>
        <div>
            <div class="slide ad1" v-if="article.news_type==2">
                <div>
                    <!-- 新闻开始 -->
                    <h1 class="media-heading">{{article.title}}</h1>
                    <p class="last">
                        <span v-show="article.source">来源：{{article.source}}</span>
                        <span v-if="article.author && clientId==410600">编辑：{{article.author}}</span>
                        <span v-if="article.author && clientId!==410600">作者：{{article.author}}</span>
                        <span v-show="article.released_at">{{format(new Date(article.released_at*1000),'YYYY-MM-DD')}}</span>
                        <span v-show="article.views||article.views==0">{{article.views}}人阅读</span>
                        <span class="type">图集</span>
                    </p>

                </div>
                <div v-show="!swiperShow" id="imgs" style="position:absolute">
                    <div class="imgs_sub">
                        <i></i>相关图集
                        <a @click="setShow()">重新浏览</a>
                    </div>
                    <ul class="clear">
                        <li class="view-imglist" v-for="(item,index) in article.relationsNews">
                            <a :href="`/news/${item.id}?article.news_type=2`">
                                <img :src="item.img_url[0]">
                                <p>{{item.title}}</p>
                            </a>
                        </li>
                    </ul>
                </div>
                <div :style="{visibility:!swiperShow?'hidden':'visible'}">
                    <div v-swiper:mySwiper="swiperOption">
                        <div class="swiper-wrapper" style="height:670px">
                            <div class="swiper-slide" style="height:670px" v-for="(banner,index) in article.body">
                                <div class="bd">
                                    <ul>
                                        <li>
                                            <img class="view-swiper-img" v-lazy="{
                                                loading: lazyLoading,
                                                error: lazyLoading,
                                                src: banner.path
                                              }" data-src="/public/w/img/wap/loading.png" alt="...">
                                        </li>
                                    </ul>
                                </div>
                                <div class="hd">
                                    <p class="hd-span">
                                        <span>{{index+1}}</span>/
                                        <span>{{article.body.length}}</span>
                                    </p>
                                    <ul>
                                        <li v-show="banner.miaoshu" class="on">{{banner.miaoshu}}</li>
                                        <li v-show="!banner.miaoshu" class="on"> </li>
                                    </ul>
                                </div>
                            </div>
             
                        </div>
                        <div class="swiper-button-prev" @click="back()" slot="button-prev"></div>
                        <div class="swiper-button-next" @click="next()" slot="button-next"></div>
                    </div>
                </div>
            </div>
        </div>

        </div>
        <div class="main clear  contents pt30 viewCopyUrl" slot="bottom">
            <footer style="margin-top: 20px;" class="clear">
                <p>转载此文章须经作者同意，并请附上出处({{websiteName}})及本页链接。</p>
                <p>原文链接：{{articleUrl}}</p>
            </footer>
            <!--       <a v-if="contentAds" :href="contentAds.content.items[0].url">
                <div class="media media-2 media-3">
                    <div class="media-left" :style="'background: url('+contentAds.content.items[0].images[0].url+') center no-repeat; background-size: cover;'">
                      <span class="type">推广</span>
                    </div>
                    <div class="media-body elip">{{contentAds.content.items[0].title}}</div>
                </div>
                </a> -->
            <div class="content-share bdsharebuttonbox bdshare-button-style0-32">
                <a class="bds-tsina pointer" @click="shareToSinaWB()" title="分享到新浪微博"></a>
                <a @mousemove="wxShareShow=true" @mouseout="wxShareShow=false" class="bds-weixin pointer" title="分享到微信"></a>
                <a class="bds-sqq pointer" @click="shareToQzone()" title="分享到QQ好友"></a>
                <a class="bds-copy pointer" title="分享到复制网址" onclick="prompt('请按下 Ctrl+C 复制代码到剪贴板',document.location)" value=""></a>
                <transition name="slide-fade">
                    <a v-if="scrollBackShow" class="pointer" style="    position: fixed; right: 90px;bottom: 100px;z-index: 500;" @click="smoothscroll()" id="top-btn"></a>
                </transition>
                <div class="wx-QRCode" v-show="wxShareShow">
                    <div id="QRCode"></div>
                    <div></div>
                </div>
            </div>
        </div>
    </Layout>

</template>
<style lang="css">
    .msg p{
        text-indent: 0 !important;
    }
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */

    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter,
    .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */

    {
        transform: translateX(10px);
        opacity: 0;
    }

    @import "~asset/news-pc/css/css.css";
    @import "~asset/news-pc/css/swiper.css";
</style>
<script>
    import Vue from 'vue';
    import VueLazyload from 'vue-lazyload';

    Vue.use(VueLazyload);
    if (process.browser) {
        const VueAwesomeSwiper = require('vue-awesome-swiper/ssr');
        Vue.use(VueAwesomeSwiper);
    }
    import {
        format
    } from 'date-fns';
    import Layout from 'component/web/news-layout';
    import newsImgAside from 'component/web/news-aside/img-aside';
    import swiper from 'component/web/swiper/swiper';
    import publicList from 'component/web/news-list/public-list';
    import axios from 'asset/news-pc/js/axios.js';
    import api from 'asset/news-pc/js/api.js';
    import Hls from 'hls.js';
    export default {
        components: {
            Layout,
            publicList,
            newsImgAside,
            swiper
        },
        computed: {
            setCityClass() {
                let cityClass = 'default';
                switch (this.clientId) {
                    case 320598:
                        cityClass = 'wj';
                        break;
                    case 410600:
                        cityClass = 'hb';
                        break;
                    case 321300:
                        cityClass = 'sq';
                        break;
                    default:
                        cityClass = 'default';
                }
                return cityClass;
            },
            lazyLoading() {
                if (this.clientId) {
                    return `/public/w/img/${this.clientId}/loading_news.png`;
                } else {
                    return '/public/w/default/loading_news.png';
                }
            }
        },
        data() {
            return {
                msg: 'msg',
                scrollBackShow: false,
                scroll: 0,
                articleUrl: '',
                swiperShow: true,
                swiperShowFlag: false,
                format,
                wxShareShow: false,
                swiperOption: {
                    pagination: '.swiper-pagination',
                    slidesPerView: 1,
                    paginationClickable: true,
                    spaceBetween: 30,
                    keyboardControl: true,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    onSlideChangeStart: swiper => {
                        if (swiper.realIndex === 0 && (swiper.previousIndex == this.data.article.body.length)) {
                            //  if (this.swiperShowFlag) {
                            this.data.swiperShow = false;
                            //    } else {
                            //      this.swiperShowFlag = true;
                            //   }
                        }
                    }
                },
                dPlayerCount: 0
            }
        },
        created () {
            this.cityClass = this.cityClass + " view";

            if (this.article.news_type == 2) {
                this.article.body = JSON.parse(this.article.body);
            } else {
                this.article.body = this.article.body.replace(/data-original/g, 'src');
            }
        }
        ,
        mounted() {
            window.addEventListener('scroll', this.showsmoothscroll)
            let pNot = document.querySelectorAll(
                '.wujiang .news-view .article .content p img,.wujiang .news-view .article .content p video,.wujiang .news-view .article .content p audio'
            )
            pNot.forEach(function (item) {
                item.parentElement.style.textIndent = "0px"
            })
            this.articleUrl = location.href;
            const QRCode = require('qrcodejs2');
            new QRCode(document.getElementById('QRCode'), location.href);
            // 取消懒加载
            var imgs = document.getElementsByClassName('lazy');
            for (var i = 0; i<imgs.length; i++) {
                imgs[i].style = {}
            }
            // 吴江视频资讯封面图、播放地址替换,支持m3u8
            if (this.clientId == 320598) {
              // this.$nextTick(() => {
                var videos = document.getElementsByTagName('video')
                for (var i = 0; i < videos.length; i++) {
                  var play_url = videos[i].src
                  var poster_url = videos[i].poster
                  if (play_url.indexOf('_1080') == -1) {
                    play_url = play_url.replace('_x256','_x256_1080')
                  }
                  if (poster_url.indexOf('_1080') == -1) {
                    poster_url = poster_url.replace('_poster','_poster_1080')
                  }

                  // var video = document.getElementById('selfVideo');
                  if (play_url.indexOf('m3u8') > -1) {
                    if (Hls.isSupported()) {
                      var hls = new Hls();
                      hls.loadSource(play_url);
                      hls.attachMedia(videos[i]);
                      hls.on(Hls.Events.MANIFEST_PARSED, function() {
                        video.play();
                      });
                    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
                      videos[i].src = play_url;
                      videos[i].addEventListener('loadedmetadata', function() {
                        videos[i].play();
                      });
                    }
                  }
                }
              // })
            }
        },
        methods: {

            showsmoothscroll() {
                this.scroll = document.documentElement.scrollTop;
                let documentTop = document.documentElement.clientHeight;
                if (this.scroll > documentTop) {
                    this.scrollBackShow = true;
                } else {
                    this.scrollBackShow = false;
                }
            },
            back() {
                if (this.mySwiper.realIndex > 0) {
                    this.mySwiper.slidePrev();
                }
            },
            next() {
                this.mySwiper.slideNext();
            },
            setShow() {
                this.swiperShowFlag = false;
                this.swiperShow = true;
                this.swiperShow = true;
            },
            // 返回顶部
            smoothscroll() {
                const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
                if (currentScroll > 0) {
                    window.requestAnimationFrame(this.smoothscroll);
                    window.scrollTo(0, currentScroll - (currentScroll / 5));
                }
            },
            // 分享到新浪微博
            shareToSinaWB(event) {
                let _shareUrl = 'http://v.t.sina.com.cn/share/share.php?&appkey=895033136'; // 真实的appkey，必选参数
                _shareUrl += '&url=' + encodeURIComponent(location.href); // 参数url设置分享的内容链接|默认当前页location，可选参数
                _shareUrl += '&title=' + encodeURIComponent(this.article.title); // 参数title设置分享的标题|默认当前页标题，可选参数
                _shareUrl += '&source=' + encodeURIComponent('');
                _shareUrl += '&sourceUrl=' + encodeURIComponent('');
                _shareUrl += '&content=' + 'utf_8'; // 参数content设置页面编码gb2312|utf_8，可选参数
                _shareUrl += '&pic=' + encodeURIComponent(this.sharePic); // 参数pic设置图片链接|默认为空，可选参数
                window.open(_shareUrl, '_blank');
            },
            // 分享到QQ
            shareToQzone() {
                const _url = document.location;
                const _showcount = 0;
                //  const _desc = 'test';
                const _summary = this.shareSummary;
                const _title = this.shareTittle;
                const _site = this.websiteName;
                const _pic = this.sharePic;
                let _shareUrl = 'http://connect.qq.com/widget/shareqq/index.html?';
                _shareUrl += 'url=' + encodeURIComponent(_url || location.href); // 参数url设置分享的内容链接|默认当前页location
                _shareUrl += '&showcount=' + _showcount || 0; // 参数showcount是否显示分享总数,显示：'1'，不显示：'0'，默认不显示
                //  _shareUrl += '&desc=' + encodeURIComponent(_desc || '分享的描述'); //参数desc设置分享的描述，可选参数
                _shareUrl += '&summary=' + encodeURIComponent(_summary || this.article.abstract); //参数summary设置分享摘要，可选参数
                _shareUrl += '&title=' + encodeURIComponent(_title || this.article.title); //参数title设置分享标题，可选参数
                _shareUrl += '&site=' + encodeURIComponent(_site || ''); // 参数site设置分享来源，可选参数
                _shareUrl += '&pics=' + encodeURIComponent(_pic || ''); // 参数pics设置分享图片的路径，多张图片以＂|＂隔开，可选参数
                window.open(_shareUrl, '_blank');
            }
        }

    };
</script>
<style>
  p video {width: 100%;}
  .content video {
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// app/web/page/news-pc/view.vue